import React from 'react';
import { HierarchyNode } from '../index';
import { GenericNodeView } from 'common/components/PreviewApprovalHierarchyReactFlow/NodeView';
import {
  MessageApprovalCreate,
  MessageApprovalCreateVariables,
} from 'common/graphql/__generated__/MessageApprovalCreate';

import ADD_NEW_MESSAGE from '../../../graphql/MessageApprovalCreate.graphql';

interface NodeViewProps {
  data: HierarchyNode;
}

export const NodeView: React.FC<NodeViewProps> = ({ data }) => (
  <GenericNodeView<
    HierarchyNode,
    MessageApprovalCreate,
    MessageApprovalCreateVariables
  >
    data={data}
    addNewMessageMutation={ADD_NEW_MESSAGE}
    getEntityId={(data) => data.entityApprovalId!}
  />
);
